module.exports = {"211382001":"东城街道","211382002":"北街街道","211382003":"南街街道","211382004":"凌北街道","211382006":"热水汤街道","211382007":"兴源街道","211382008":"红山街道","211382009":"城关街道","211382101":"万元店镇","211382102":"宋杖子镇","211382103":"三十家子镇","211382104":"杨杖子镇","211382105":"刀尔登镇","211382106":"松岭子镇","211382107":"四官营子镇","211382108":"沟门子镇","211382110":"小城子镇","211382111":"四合当镇","211382113":"乌兰白镇","211382114":"瓦房店镇","211382115":"大河北镇","211382116":"牛营子镇","211382117":"三道河子镇","211382204":"大王杖子乡","211382205":"刘杖子乡","211382206":"前进乡","211382210":"北炉乡","211382217":"三家子蒙古族乡","211382219":"佛爷洞乡","211382220":"河坎子乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/211382.json
// module id = 548
// module chunks = 0